import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import { Row, Col, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Card, CardHeader, CardFooter, CardBody, Collapse, Form, FormGroup, FormText, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Table, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import $ from 'jquery'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import AcademicPage from '../../views/AcademicPage/';

const GLOBAL = require('../../Globals');

class ClassTeacherAllocation extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: '',
			acyear: '',
			cls: '',
			section: '',
			teacher: '',
			_message: '',
			alertClass: '',
			posts: [],
			secs: [],
			teach: [],
			data: [],
			accyear: [],
			_redirect: false,
			modal: false,
			alsec: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onSelectChange = this.onSelectChange.bind(this);
	}

	/** this function will be call when page loading **/
	componentWillMount() {
		this.getteacher();
		this.getacyear();
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	onSelectChange(e) {
		this.setState({ teacherValue: e });
		this.state.teacher = e.value;
	}

	handleChange(id, sec, e) {
		this.setState({
			modal: !this.state.modal
		});
		this.state.cls = id;
		this.state.section = sec;
	}

	onChange(e) {
		// this.setState({[e.target.name]:e.target.value});
		this.state.acyear = e.target.value;
		this.getclass();
		this.getsection();
		this.getdata();
		this.getallsection();
	}

	onClick() {

		document.getElementById("userform").reset();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('teacherallocation/add', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				if (this.state.teacher != '') {
					this.setState({
						_message: 'Class Teacher Allocated Successfully!..',
						alertClass: 'alert alert-success',
					});
				}
				else {

					this.setState({
						_message: 'Class Teacher Removed Successfully!..',
						alertClass: 'alert alert-success',
					});
				}
				this.setState({ teacher: '' });
				this.getdata();
				this.getteacher();
				this.toggle();
			}
			else {

				this.setState({
					_message: 'Error!..',
					alertClass: 'alert alert-danger',
				});
			}
		});
	}

	handleClick(dd) {

		this.state.id = dd;

		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('teacherallocation/deletedetails', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'ClassTeacherAllocation Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove ClassTeacherAllocation',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	onUpdate(dt) {

		this.state.idd = dt;
		this.setState({ _redirect: true });

	}

	getallsection() {
		var ac = this.state.acyear;
		GetData('section/getsecbyacyear/' + ac).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					alsec: responseJson
				});
			}
		});
	}

	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	getsection() {

		GetData('section/getsection').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					secs: responseJson
				});
			}
		});
	}

	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getclass();
				this.getsection();
				this.getdata();
				this.getallsection();
			}
		});
	}

	getdata() {
		var ac = this.state.acyear;
		GetData('teacherallocation/getdetails/' + ac).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	/** get Teacher **/
	getteacher() {
		$("#showLoader").show();

		GetData('teacherallocation/getteacher').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					teach: responseJson
				});
			}
		});
	}

	getselect(index, id) {

		var formFields = [];

		for (var i = 1; i < 11; i++) {

			if (this.getclssec(id, i)) {
				formFields.push(<td className="clstea"><Button id="teatext" data-toggle="tooltip" data-placement="top" title={this.getclassec(id, i)} size="sm" color="danger" onClick={this.handleChange.bind(this, id, i)}>{this.getclssec(id, i)}</Button></td>);
			}
			else {
				if (this.checkclssec(id, i)) {
					formFields.push(<td className="clstea"><Button size="sm" color="primary" onClick={this.handleChange.bind(this, id, i)}> Select</Button></td>);
				}
				else {
					formFields.push(<td className="clstea"></td>);
				}
			}

		}
		return (formFields);
	}
	/** Allocated Class & Section **/
	checkclssec(cls, sec) {
		var bstate = false;
		for (var j = 0; j < this.state.alsec.length; j++) {

			if (this.state.alsec[j].clas == cls && this.state.alsec[j].section == sec) {

				bstate = true;
				break;
			}
			else {
				bstate = false;
			}

		}
		return bstate;
	}

	/** Allocated Teacher by Class & Section **/
	getclssec(cls, sec) {
		var boolstate = false;
		for (var ii = 0; ii < this.state.data.length; ii++) {

			if (this.state.data[ii].clas == cls && this.state.data[ii].section == sec) {

				boolstate = this.state.data[ii].emp;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	/** Allocated Teacher by Class & Section for tooltip **/
	getclassec(cls, sec) {
		var boolstate = false;
		for (var ii = 0; ii < this.state.data.length; ii++) {

			if (this.state.data[ii].clas == cls && this.state.data[ii].section == sec) {

				boolstate = this.state.data[ii].empname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/academic/editteacherallocate/' + this.state.idd} />);

		}

		if (this.state.acyear != '') {

			/* this.getdata(this.state.acyear);
			this.getclass(this.state.acyear);
			this.getsection(this.state.acyear); */
			$("#teatable").show();
			$("#clsteabody").show();
		}
		else {

			$("#teatable").hide();
			$("#clsteabody").hide();
		}

		var items = this.state.posts;
		var sec = this.state.secs;
		// var tea = this.state.teach;
		var acyear = this.state.accyear;

		var tea = [];
		/** map Teacher value to react multi select **/
		this.state.teach.map(function (e, key) {
			tea.push(
				{ value: e.id, label: e.empname }
			);
		});

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
									<CardHeader>
										<strong>Class Teacher Allocation</strong>
										&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
							 <select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
									</CardHeader>
									<CardBody id="clsteabody">
										<Row>
											<Col md="12">
												<Table responsive bordered id="teatable">
													<thead>
														<tr>
															<td>#</td>
															{this.state.secs.map(item =>

																<td>{item.section}</td>
															)}
														</tr>
													</thead>
													<tbody>
														{this.state.posts.map((item, index) =>
															<tr>
																<td className="clstea" key={index}>{item.class}</td>
																{this.getselect(index, item.id)}
															</tr>
														)}
													</tbody>
												</Table>
											</Col>
											<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
												<ModalHeader toggle={this.toggle}>Select Class Teacher</ModalHeader>
												<ModalBody>
													{/*<select name="teacher" onChange={this.onSelectChange} className="form-control" required>
									<option value="">Select Teacher</option>
									{
										tea.map(function (item) {
											return <option value={item.id }>{item.empname}</option>;
										})
									}
									</select>*/}
													<Select value={this.state.teacherValue} onChange={this.onSelectChange} options={tea} />
												</ModalBody>
												<ModalFooter>
													<Button type="submit" color="primary" onClick={this.onSubmit}>Submit</Button>
													<Button color="secondary" onClick={this.toggle}>Cancel</Button>
												</ModalFooter>
											</Modal>
										</Row>
									</CardBody>
								</form>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default ClassTeacherAllocation;


// WEBPACK FOOTER //
// ./src/academic/Teacher/ClassTeacherAllocation.js